// components/ProductCard.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/productCard.css';

function ProductCard({ product }) {
  const navigate = useNavigate();

  return (
    <div className="product-card" onClick={() => navigate(`/product/${product.id}`)}>
      <img src={product.image} alt={product.name} className="product-img" />
      <h2>{product.name}</h2>
      <p>{product.description}</p>
      <h3>${product.price.toFixed(2)}</h3>
      <p>⭐ {product.rating}</p>
    </div>
  );
}

export default ProductCard;
